import React from 'react';
import type { CheckboxGroupProps } from './Checkbox.props';
import Checkbox from './Checkbox';
import Box from 'components/Box';

const CheckboxGroup = <T,>({ value, onChange, options, direction = 'row' }: CheckboxGroupProps<T>) => {

  const handleChange = (val: T) => {
    if (value?.includes(val)) {
      onChange?.(value.filter(v => v !== val));
    } else {
      onChange?.([...(value || []), val]);
    }
  };

  const isChecked = (val: T): boolean => {
    if (!val) return false;

    return value?.includes(val) || false;
  };

  return (
    <Box width='100%' flexDirection={direction} display='flex' gap={direction === 'row' ? '12' : '3'} className='custom-checkbox-group'>
      {options.map((option, index) => (
        <Checkbox
          key={index}
          label={option.label}
          value={isChecked(option.value)}
          onChange={() => handleChange(option.value)}
        />
      ))}
    </Box>
  );
};

export default CheckboxGroup;
